import React, { useEffect } from 'react'
import { FiMapPin } from 'react-icons/fi'
import { useSelector, useDispatch } from 'react-redux'
import { setLocationDetails } from '../../features/location/locationSlice'
import { updateIrradiance } from '../../features/solarSource/solarSourceSlice'
import { calculatePower } from '../../features/solarSource/solarSourceSlice'


const Location = () => {
    const { latitude, longitude } = useSelector(store => store.location)
    const dispatch = useDispatch()

    const fetchData = async () =>{
        try {
            fetch(`https://api.weatherbit.io/v2.0/current?lat=${latitude}&lon=${longitude}&key=8486c6ef020d4d11b5852d6c7b172a35&include=hourly`)
            .then(res => res.json())
            .then((jsonData)=>{
                const data = jsonData.data[0]
                dispatch(setLocationDetails({
                    city_name: data.city_name,
                    state_code: data.state_code,
                    country_code: data.country_code
                }))
                dispatch(updateIrradiance(data.ghi))
                dispatch(calculatePower())
            })
        } catch (error) {
            console.log(error)
        }

    }

    useEffect(()=>{
        fetchData()
    }, [latitude, longitude])

    const {city_name, state_code, country_code} = useSelector(store => store.location)
    return (
        <div className='p-2 flex gap-1 items-center text-black bg-slate-400 w-full rounded-md'>
            <FiMapPin className='text-white text-xl'/>
            {
                city_name === ''? (
                    <p>No location information</p>
                    ):(
                    <>
                        <p>{city_name},</p>
                        <p>{state_code},</p>
                        <p>{country_code}</p>
                    </>
                )
            }
        </div>
    )
}

export default Location